import { render, staticRenderFns } from "./PostCreateDialog.vue?vue&type=template&id=270c150b&scoped=true"
import script from "./PostCreateDialog.vue?vue&type=script&lang=js"
export * from "./PostCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c150b",
  null
  
)

export default component.exports